import styled from 'styled-components'

export const StyledHeadline = styled.h1`
  padding-bottom: 1em;
`
